import Vue from 'vue'
import VueRouter from 'vue-router'
import accounts from './accounts'
import records from './records'
import quoting from './quoting'
import tickets from './tickets'
import administration from './administration'
import fulfillment from './fulfillment'
import external from './external'
import verify from './verify'
import quotingSme from './quotingSme'
import csHome from './home'
import sme from './sme'
import marketing from '@router/marketing'
import privateCarList from '@router/./privateCarList'
import enquiry from '@router/./enquiry'
import team from './team'
import store from '@/store'

Vue.use(VueRouter)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/home'),
      redirect: '/cs-home',
      children: [
        ...accounts,//用户
        ...records,//记录
        ...quoting,//报价
        ...tickets,//票
        ...administration,//行政 管理
        ...fulfillment,//履行
        ...external,//外部
        ...quotingSme, //sme
        ...csHome,// cs home
        ...marketing,
        ...privateCarList,
        ...sme,
        ...enquiry,
        ...team,
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/login')
    },
    ...verify,
    // {
    //   path: '/reset/password',
    //   name: 'resetPassword',
    //   component: () => import('../views/verify/reset-password'),
    // },
    // {
    //   path: '/reset/verify',
    //   name: 'verify',
    //   component: () => import('../views/verify/verify'),
    // },
    {
      path: '/page/dashboard',
      name: 'dashboardView',
      component: () => import('../views/administration/dashboardView')
    },
    // {
    //   path: '/test',
    //   name: 'Test',
    //   component: () => import('../views/test')
    // },
    {
      path: '/post/preview',
      name: 'PostPreview',
      component: () => import('../views/administration/post-preview-page'),
    }
  ]
})


router.beforeEach((to, from, next) => {
  const { path, fullPath } = to
  const token = localStorage.getItem('token')
  const isVerified = localStorage.getItem('isVerified')
  const externalPage = ['/login', '/reset/password', '/reset/verify']
  store.dispatch('request/removeHttpRequestList')
  if(externalPage.indexOf(path)==-1&& (!token||!isVerified)) {
    next({ path: `/login?fullPath=${fullPath}` })
  }
  else {
    next()
  }
})

router.afterEach(() => {
  let scrollContent = document.querySelector('.scroll-content')
  if (scrollContent) {
    scrollContent.scrollTop = 0
  }
})

export default router
